import { Controller } from 'stimulus'
import { prepareFleetPreview } from 'src/lane_matrix/fleet_preview'

export default class extends Controller {
  static targets = ['payload', 'container', 'status']

  connect() {
    this.generation = (this.generation || 0) + 1
    const inspector = this.element.closest('[data-controller~="matrix-inspector"]')
    this.paused = !this.element.closest('dialog') && Boolean(inspector?.querySelector('dialog[open]'))
    this.element.dataset.renderingPaused = this.paused
    this.handleSelected = this.handleSelected.bind(this)
    this.containerTarget.addEventListener('fleet:item-selected', this.handleSelected)
    this.containerTarget.addEventListener('fleet:load-selected', this.handleSelected)
    this.mount(this.generation)
  }

  disconnect() {
    this.generation += 1
    this.containerTarget.removeEventListener('fleet:item-selected', this.handleSelected)
    this.containerTarget.removeEventListener('fleet:load-selected', this.handleSelected)
    this.renderer?.destroy()
    this.renderer = null
  }

  async mount(generation) {
    try {
      const payload = JSON.parse(this.payloadTarget.textContent)
      const trailer3d = await import('src/tractor_trailer_3d')
      if (generation !== this.generation) return
      this.items = prepareFleetPreview(payload.fleet_items || [], trailer3d, 100)
      if (!this.items.length) throw new Error('No saved truck geometry is available for this page.')
      this.renderer = trailer3d.createFleetRenderer(this.containerTarget)
      this.renderer.render({ items: this.items, autoSelect: false, showScaleFigure: true })
      this.renderer.setPaused(this.paused)
      this.element.dataset.renderedTruckCount = this.items.length
      this.statusTarget.hidden = true
    } catch (error) {
      if (generation !== this.generation) return
      this.renderer?.destroy()
      this.renderer = null
      this.statusTarget.textContent = 'The 3D preview could not be displayed. Use Truck details below to inspect a saved plan.'
    }
  }

  pauseBehindInspector(event) {
    if (this.element.closest('dialog')) return
    this.paused = event.type === 'matrix-inspector:opened'
    this.element.dataset.renderingPaused = this.paused
    this.renderer?.setPaused(this.paused)
  }

  handleSelected(event) {
    const item = this.items?.find(item => item.key === event.detail?.key)
    if (item?.inspection_url) this.element.dispatchEvent(new CustomEvent('fleet-preview:inspect', {
      bubbles: true, detail: { url: item.inspection_url, opener: this.containerTarget },
    }))
  }

  navigate(event) {
    if (event.currentTarget.dataset.camera === 'fit') {
      this.renderer?.selectItem(null)
      this.renderer?.fitView('fleet')
    } else {
      this.renderer?.navigateView(event.currentTarget.dataset.camera)
    }
  }
}
